import {Outlet} from "react-router";
import {ProzorDimenzijeProvider} from "../hooks/useProzorDimenzije";
import { fetchAndStoreData } from "../dataService";
import { useEffect } from "react";

const RootLayout = () => {
    useEffect(() => {
        fetchAndStoreData();
    }, []);
    return (
        <ProzorDimenzijeProvider>
            <Outlet />
        </ProzorDimenzijeProvider>
    );
};


    export default RootLayout;